import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  CircularProgress,
  LinearProgress,
  Paper,
} from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";
import { checkRootPermission } from "../../contexts/services/admin/securityServices";
import SecurityIcon from "@mui/icons-material/Security";

const SecurityChecking = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default", // Use MUI theme background
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* 顶部动态安全进度条 */}
        <LinearProgress
          color='primary'
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: 4,
          }}
        />

        <Stack alignItems='center' spacing={3}>
          {/* 带有呼吸感外圈的安全图标容器 */}
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              borderRadius: "50%",
              bgcolor: "primary.lighter",
              border: "1px solid",
              borderColor: "primary.light",
            }}
          >
            <CircularProgress
              size={56}
              thickness={4}
              disableShrink
              color='primary'
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SecurityIcon
                sx={{
                  fontSize: 32,
                  color: "primary.main",
                }}
              />
            </Box>
          </Box>

          <Stack spacing={1}>
            <Typography
              variant='h6'
              fontWeight={700}
              color='text.primary'
              sx={{
                fontFamily: '"Roboto Mono", monospace',
                letterSpacing: "0.5px",
              }}
            >
              SECURITY CHECK
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              Verifying root access permissions...
            </Typography>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

const AdminGuard = ({ children }) => {
  const location = useLocation();
  const [isCheckingSecurity, setIsCheckingSecurity] = useState(true);
  const [isRoot, setIsRoot] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const validateRootPermission = async () => {
      try {
        const { data } = await checkRootPermission();

        if (isMounted) {
          setIsRoot(Boolean(data?.isRoot));
        }
      } catch (error) {
        if (isMounted) {
          setIsRoot(false);
        }
      } finally {
        if (isMounted) {
          setIsCheckingSecurity(false);
        }
      }
    };

    validateRootPermission();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isCheckingSecurity) {
    return <SecurityChecking />;
  }

  if (!isRoot) {
    return <Navigate to='/consolePanel' state={{ from: location }} replace />;
  }

  return children;
};

export default AdminGuard;
